
















import { defineComponent, onMounted, onUnmounted, ref } from "@vue/composition-api";
import { getNow } from "@/lib/time";
import BaseButton from "@/components/BaseButton";
import BaseIcon from "@/components/BaseIcon";

export default defineComponent({
  name: "LeavingPrivate",
  components: { BaseButton, BaseIcon },
  setup(props, { emit }) {
    const timeLeft = ref(30);
    let timer: ReturnType<typeof setInterval>;
    onMounted(() => {
      const createdTime = getNow();
      timer = setInterval(() => {
        timeLeft.value = Math.floor(30 - (getNow().getTime() - createdTime.getTime()) / 1000);
        if (timeLeft.value === 0) emit("confirm");
      }, 100);
    });

    onUnmounted(() => {
      clearInterval(timer);
    });

    return {
      timeLeft,
    };
  },
});
